import { render, staticRenderFns } from "./AdminStreamTailorPayments.vue?vue&type=template&id=20b0a188&"
import script from "./AdminStreamTailorPayments.vue?vue&type=script&lang=ts&"
export * from "./AdminStreamTailorPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports